// src/views/MainPage/RootHeader.lazy.js
import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

// Chỉ export RootHeader, không kéo cả MainHeader.js
const RootHeaderLazy = createLazyComponent(() =>
    import('./MainHeader').then(m => ({default: m.RootHeader}))
)
export const RootHeader = (props) => <RootHeaderLazy {...props} />